import { render, staticRenderFns } from "./sela_concept_detail.vue?vue&type=template&id=152e3b3d&scoped=true"
import script from "./sela_concept_detail.vue?vue&type=script&lang=js"
export * from "./sela_concept_detail.vue?vue&type=script&lang=js"
import style0 from "./sela_concept_detail.vue?vue&type=style&index=0&id=152e3b3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e3b3d",
  null
  
)

export default component.exports